"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Base_1 = __importDefault(require("./Base"));

var Modal_styles_1 = require("./Base/Modal.styles");

var ContainedContent = styled_components_1.default(Modal_styles_1.ModalContent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: calc(100% - 48px);\n  height: 440px;\n  border-radius: 4px;\n"], ["\n  width: calc(100% - 48px);\n  height: 440px;\n  border-radius: 4px;\n"])));

var ContainedModal = function ContainedModal(props) {
  return react_1.default.createElement(Base_1.default, __assign({
    Content: ContainedContent
  }, props));
};

exports.default = ContainedModal;
var templateObject_1;